var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"beta-badge border-bottom py-2 bg-white"},[_c('div',{staticClass:"beta-badge-topbar align-items-center"},[_c('div',{staticClass:"beta-badge-topbar-item beta-text text-h5 ma-auto"},[_vm._v(" "+_vm._s(_vm.$t("general.beta"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }